<template>
  <NavBar
    :app-title="`${title} (${useContractorStore().contractor.name})`"
    :page-title="$route.meta.title as string"
    :apps="useAuth().session.value.applications"
    :session="useAuth().session.value"
    @sign-out="useAuth().signOut"
  />

  <div class="main-app d-flex h-screen">
    <NavDrawer />

    <v-navigation-drawer expand-on-hover rail :mobile="false" class="sidebar">
      <v-list nav>
        <v-list-item
          prepend-icon="$stream"
          title="WIP"
          :to="{ name: 'wip' }"
          color="primary"
        />
        <v-list-item
          prepend-icon="$complete"
          title="Completed"
          :to="{ name: 'completed' }"
          color="primary"
        />
      </v-list>
    </v-navigation-drawer>

    <div class="w-100 overflow-y-auto">
      <router-view v-slot="{ Component }">
        <Transition :mode="'out-in'" :appear="true">
          <Suspense>
            <v-main class="overflow-y-auto pa-8 h-100">
              <component :is="Component" />
            </v-main>

            <template #fallback>
              <v-progress-circular />
            </template>
          </Suspense>
        </Transition>
      </router-view>
    </div>
  </div>
</template>

<script setup lang="ts">
import NavDrawer from '@/components/NavDrawer.vue'
import { init } from '@/lib/flags'
import { useContractorStore } from '@/stores/contractor'
import { useAuth } from '@simplifi/auth'
import { NavBar } from '@simplifi/components'

init()

const title = import.meta.env.VITE_APP_TITLE
</script>

<style scoped>
.sidebar {
  position: static !important;
  height: 100% !important;
}
</style>
